import { Container } from "@material-ui/core";
import HeaderClientes from "components/_refactor/headers/clients";
import InitialRequestPage from "./views/initial-page";
import NewRequestPage from "./views/new-request";
import { useState } from "react";

export default function SolicitacaoDevolucao() {
  const [newRequestPage, setNewRequestPage] = useState(false);

  const onNewRequest = () => {
    setNewRequestPage(true);
  };

  const onBack = () => {
    setNewRequestPage(false);
  };

  return (
    <>
      <HeaderClientes
        section="Solicitação de Devolução"
        subsection="Serviços"
      />
      <Container style={{ marginTop: "-4rem" }} maxWidth={false}>
        {newRequestPage ? (
          <NewRequestPage onBack={onBack} />
        ) : (
          <InitialRequestPage onNewRequest={onNewRequest} />
        )}
      </Container>
    </>
  );
}
